import ApiService from '../../components/api_services/apiService.jsx';
import { Eye, Download } from 'lucide-react';
import { toggleCheckedItem } from '../../store/documentsTabSlice';

// Helper function to map category from API to endpoint format
const mapCategoryToEndpoint = (category) => {
  const categoryMap = {
    'Rachunek': 'invoice',
    'Time sheet': 'daily-timesheet',
    'Time sheet weekly': 'weekly-timesheet',
  };
  return categoryMap[category] || category.toLowerCase().replace(/\s+/g, '-');
};

// Helper function to format date
const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  } catch (e) {
    return dateString;
  }
};

export const fetchDocuments = async (
  sortBy,
  sortDirection,
  currentPage,
  dispatch,
  setMaxPages,
  setRows,
  setTotalCount,
  setDocumentsData,
  checkedItems,
  search,
  category,
  status,
  userId,
  createdFrom,
  createdTo
) => {
  try {
    // Build query parameters
    const params = {
      page: currentPage,
      size: 20,
      ...(sortBy && sortDirection && { sortBy, sortDirection }),
      ...(search && { search }),
      ...(category && { category }),
      ...(status && { status }),
      ...(userId && { userId }),
      ...(createdFrom && { createdFrom }),
      ...(createdTo && { createdTo }),
    };

    // Fetch documents and count in parallel
    const [documentsResponse, countResponse] = await Promise.all([
      ApiService.getDocuments(params),
      ApiService.getDocumentsCount(params),
    ]);

    const documents = documentsResponse.documents || [];
    const totalCount = countResponse.total || 0;
    const totalPages = documentsResponse.totalPages || 1;

    dispatch(setMaxPages(totalPages));
    dispatch(setTotalCount(totalCount));

    // Store document metadata for select all functionality
    const documentsData = documents.map((doc) => ({
      id: doc.id.toString(),
      category: mapCategoryToEndpoint(doc.category),
    }));
    if (setDocumentsData) {
      setDocumentsData(documentsData);
    }

    // Map documents to table rows
    const mappedRows = documents.map((doc) => {
      const categoryEndpoint = mapCategoryToEndpoint(doc.category);
      const isChecked = checkedItems.some(
        (item) => item.category === categoryEndpoint && item.id === doc.id.toString()
      );

      return [
        <input
          key={`checkbox-${doc.id}`}
          type="checkbox"
          checked={isChecked}
          onChange={() => {
            dispatch(
              toggleCheckedItem({
                category: categoryEndpoint,
                id: doc.id.toString(),
              })
            );
          }}
        />,
        doc.id || '',
        doc.documentName || '',
        formatDate(doc.createdAt),
        doc.userName || '',
        doc.status === 'SENT' ? (
          <span className="status-checkmark">✓</span>
        ) : doc.status ? (
          <span className="status-text">{doc.status}</span>
        ) : (
          ''
        ),
        <span
          key={`category-${doc.id}`}
          className={`category-badge category-${categoryEndpoint}`}
        >
          {doc.category}
        </span>,
        <div key={`actions-${doc.id}`} className="document-actions">
          <button
            className="action-button preview-button"
            onClick={() => ApiService.previewDocument(categoryEndpoint, doc.id)}
            title="Podgląd"
          >
            <Eye size={16} />
          </button>
          <button
            className="action-button download-button"
            onClick={() => ApiService.downloadDocument(categoryEndpoint, doc.id)}
            title="Pobierz"
          >
            <Download size={16} />
          </button>
        </div>,
      ];
    });

    setRows(mappedRows);
  } catch (error) {
    console.error('Błąd podczas pobierania dokumentów:', error);
    setRows([]);
  }
};

